import React from "react";
import { Check, X } from "lucide-react";

export const ComparisonTable: React.FC = () => {
  const competitors = [
    {
      name: "Salbox",
      color: "bg-salbox-primary",
      platformCommission: "0%",
      taxCommission: "0%",
      hiddenFees: "0%",
      madeToOrder: true,
      isWinner: true,
    },
    {
      name: "Rappi",
      color: "bg-orange-500",
      platformCommission: "30%",
      taxCommission: "12.5%",
      hiddenFees: "25%",
      madeToOrder: false,
    },
    {
      name: "Uber Eats",
      color: "bg-black",
      platformCommission: "30%",
      taxCommission: "12.5%",
      hiddenFees: "25%",
      madeToOrder: false,
    },
    {
      name: "Didi Food",
      color: "bg-blue-600",
      platformCommission: "30%",
      taxCommission: "12.5%",
      hiddenFees: "25%",
      madeToOrder: false,
    },
  ];

  return (
    <section id="comparacion" className="py-16 bg-gray-50 scroll-mt-20">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-lufga-semibold text-gray-800 mb-4 uppercase">
            ¿Por qué elegir Salbox?
          </h2>
          <p className="text-lg font-lufga text-gray-600 max-w-3xl mx-auto">
            Compara y descubre por qué Salbox es la mejor opción para tu
            negocio. Sin comisiones ocultas, sin sorpresas desagradables.
          </p>
        </div>

        {/* Comparison Table - All screens */}
        <div className="max-w-6xl mx-auto">
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gray-100">
                  <th className="p-6 text-left font-lufga-semibold text-gray-800">
                    Característica
                  </th>
                  {competitors.map((competitor) => (
                    <th
                      key={competitor.name}
                      className={`p-6 text-center text-white font-lufga-bold ${
                        competitor.color
                      } ${
                        competitor.isWinner
                          ? "ring-4 ring-salbox-primary/30"
                          : ""
                      }`}
                    >
                      {competitor.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {/* Comisión Plataforma */}
                <tr className="border-b border-gray-100">
                  <td className="p-6 font-lufga-medium text-gray-800">
                    Comisión Plataforma
                  </td>
                  {competitors.map((competitor) => (
                    <td key={competitor.name} className="p-6 text-center">
                      <span
                        className={`font-lufga-bold ${
                          competitor.platformCommission === "0%"
                            ? "text-salbox-primary"
                            : "text-salbox-secondary"
                        }`}
                      >
                        {competitor.platformCommission}
                      </span>
                    </td>
                  ))}
                </tr>

                {/* Impuesto México */}
                <tr className="border-b border-gray-100 bg-gray-50/50">
                  <td className="p-6 font-lufga-medium text-gray-800">
                    Impuesto México
                  </td>
                  {competitors.map((competitor) => (
                    <td key={competitor.name} className="p-6 text-center">
                      <span
                        className={`font-lufga-bold ${
                          competitor.taxCommission === "0%"
                            ? "text-salbox-primary"
                            : "text-salbox-secondary"
                        }`}
                      >
                        {competitor.taxCommission}
                      </span>
                    </td>
                  ))}
                </tr>

                {/* Cargos Ocultos */}
                <tr className="border-b border-gray-100">
                  <td className="p-6 font-lufga-medium text-gray-800">
                    Cargos Ocultos
                  </td>
                  {competitors.map((competitor) => (
                    <td key={competitor.name} className="p-6 text-center">
                      <span
                        className={`font-lufga-bold ${
                          competitor.hiddenFees === "0%"
                            ? "text-salbox-primary"
                            : "text-salbox-secondary"
                        }`}
                      >
                        {competitor.hiddenFees}
                      </span>
                    </td>
                  ))}
                </tr>

                {/* Hecho al Momento */}
                <tr className="border-b border-gray-100 bg-gray-50/50">
                  <td className="p-6 font-lufga-medium text-gray-800">
                    Hecho al Momento
                  </td>
                  {competitors.map((competitor) => (
                    <td key={competitor.name} className="p-6 text-center">
                      {competitor.madeToOrder ? (
                        <Check className="w-6 h-6 text-salbox-primary mx-auto" />
                      ) : (
                        <X className="w-6 h-6 text-salbox-secondary mx-auto" />
                      )}
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};
